import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const CardRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  :hover {
    box-shadow: 0px 6px 6px -3px rgba(0, 0, 0, 0.2);
  }
  /* min-width: 197px;
  max-width: 197px; */
  /* height: 266px; */
  margin: 5px;
  ${(props) =>
    props.highlight === true &&
    `
    margin: 0px;
    border: 5px solid ${props.theme.palette.primary.light01};
  `}
`;


const GroupDetail = styled(Box)`
  width: 100%;
`;

const ContainerName = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 42px;
  box-sizing: border-box;
  ${(props) =>
    props.selectLevel === true &&
    `
    background: ${props.theme.palette.primary.main};
  `}
`;

const ContentText = styled(Box)`
  color: ${(props) => props.theme.palette.primary.main};
  ${(props) =>
    props.selectLevel === true &&
    `
    color: #FFFFFF; 
  `}
  font-size: "17px";
  font-weight: 600;
`;

const CardShowLeveLSetting = ({
  image,
  imageHover,
  title,
  selectLevel = false,
  highlight = false,
  width = 197,
  height = 224,
}) => {
  return (
    <CardRoot selectLevel={selectLevel} highlight={highlight}>
      <img
        src={image}
        onMouseOver={(e) => {
          imageHover && (e.currentTarget.src = imageHover);
        }}
        onMouseOut={(e) => {
          imageHover && (e.currentTarget.src = image || "");
        }}
        alt={"level"}
        width={width}
        height={height}
        style={{ objectFit: "cover" }}
      />
      <GroupDetail>
        <ContainerName selectLevel={selectLevel}>
          <ContentText selectLevel={selectLevel}>{title}</ContentText>
        </ContainerName>
      </GroupDetail>
    </CardRoot>
  );
};

export default CardShowLeveLSetting;
